const strings = {
  labels: {
    valueColumn: 'Contact Methods',
    memoColumn: 'Memo',
    notificationsColumn: 'Notifications',
    editButton: 'Edit Contact',
    backToView: 'Back to View',
    breadCrumbs: {
      contactMethods: 'Contact Methods',
      editContacts: 'Edit Contacts',
    },
  },
  placeholders: {
    search: 'Search by contact name, title or method',
  },
} as const;

export default strings;
